// scanner-modal/scanner-modal.component.ts
import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BrowserQRCodeReader } from '@zxing/browser';
import { NotFoundException } from '@zxing/library';

@Component({
  selector: 'app-scanner-modal',
  templateUrl: './scanner-modal.component.html',
  styleUrls: ['./scanner-modal.component.scss'],
})
export class ScannerModalComponent implements AfterViewInit, OnDestroy {
  scanResult: string = '';
  errorMessage: string = '';
  private codeReader = new BrowserQRCodeReader();
  private stream: MediaStream | null = null;

  constructor(private modalController: ModalController) {}

  async ngAfterViewInit() {
    await this.startScan();
  }

  async startScan() {
    try {
      const video = document.getElementById('video') as HTMLVideoElement;
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
      });
      video.srcObject = this.stream;
      video.play();

      // Draw scanning rectangle
      this.drawScanOverlay();

      const result = await this.codeReader.decodeOnceFromVideoElement(video);
      this.scanResult = result.getText();
      await this.dismiss({ result: this.scanResult });
    } catch (err) {
      if (err instanceof NotFoundException) {
        this.errorMessage = 'Tidak ada QR code yang terdeteksi';
      } else {
        this.errorMessage = 'Error: ' + err;
      }
    }
  }

  drawScanOverlay() {
    const video = document.getElementById('video') as HTMLVideoElement;
    const canvas = document.getElementById('overlay') as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const draw = () => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      ctx.strokeStyle = 'var(--ion-color-primary, #3880ff)';
      ctx.lineWidth = 4;
      const size = Math.min(canvas.width, canvas.height) * 0.6;
      const x = (canvas.width - size) / 2;
      const y = (canvas.height - size) / 2;
      ctx.strokeRect(x, y, size, size);
      requestAnimationFrame(draw);
    };
    video.onloadedmetadata = draw;
  }

  async dismiss(data?: any) {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
    }
    await this.modalController.dismiss(data);
  }

  ngOnDestroy() {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
    }
  }
}